import { orderBy } from 'lodash'
import {
  CATALOG_TAXONOMY_PHOTOS_STORAGE_PATH,
  CATALOG_TAXONOMY_SEO_OG_STORAGE_PATH,
} from '../../seo/storagePaths'
import { seoOgStorageChildPath } from '../../seo/persistableMediaObject'

/**
 * Collect Storage paths for taxonomy node photos + SEO OG.
 */
export function collectCatalogTaxonomyStoragePaths(nodes = []) {
  const paths = []

  nodes.forEach((node) => {
    if (!node?.id) return

    const photos = Array.isArray(node.photos) ? node.photos : []
    photos.forEach((photo) => {
      if (!photo?.fileName || !photo?.fileExt) return
      const root = photo.storagePath || CATALOG_TAXONOMY_PHOTOS_STORAGE_PATH
      paths.push(`${root}/${node.id}/${photo.fileName}.${photo.fileExt}`)
    })

    const og = node.seo?.ogImage
    if (og) {
      const ogPath = seoOgStorageChildPath(node.id, og, CATALOG_TAXONOMY_SEO_OG_STORAGE_PATH)
      if (ogPath) paths.push(ogPath)
    }
  })

  return [...new Set(paths)]
}

/**
 * Best-effort delete; returns { deleted, failed }.
 */
export async function cleanupCatalogTaxonomyStoragePaths(paths = [], storageRefApi) {
  const deleted = []
  const failed = []

  if (!storageRefApi || !paths.length) {
    return { deleted, failed: paths.slice() }
  }

  await Promise.all(
    paths.map(async (path) => {
      try {
        await storageRefApi.child(path).delete()
        deleted.push(path)
      } catch (error) {
        console.log('cleanupCatalogTaxonomyStoragePaths', path, error)
        failed.push(path)
      }
    })
  )

  return { deleted, failed }
}

export function orderNodesForCleanupLogging(nodes = []) {
  return orderBy(nodes, ['depth', 'name'], ['asc', 'asc'])
}
